import { getLineItemStateName } from '@printdeal/business-logic';

const ENV = process.env.GATSBY_ACTIVE_ENV === 'production' ? 'prod' : 'staging';
const shouldSkipReview = (lineItem) => {
  const state = getLineItemStateName(lineItem, ENV);
  return ['Shipped', 'PrintingInProgress', 'FulfillmentAccepted'].includes(state);
};

const getReorderLineItems = (order, reorderLineItem) => {
  if (reorderLineItem.custom.fields.isReviewGroupLead) {
    return order.lineItems.filter(
      (lineItem) => lineItem.custom.fields.reviewGroup === reorderLineItem.custom.fields.reviewGroup,
    );
  }

  return [reorderLineItem];
};

const getDocRefCopy = async (documentReferenceField, designsApi) => {
  const documentReference = documentReferenceField[0].split('DocumentReferenceUrl:')[1];
  const url = new URL(documentReference);
  const [newPathName] = url.pathname.split('/docref');
  url.pathname = newPathName;
  const newDocRef = await designsApi.duplicateDocRef(url.href);
  return [`DocumentReferenceUrl:${newDocRef}`];
};

export {
  getReorderLineItems,
  shouldSkipReview,
  getDocRefCopy,
};
